// @ts-check
import React from 'react';
import { Select, MenuItem, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Flex, ButtonFilled } from 'Components/Base';

const Wrapper = styled(Flex)`
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`;

const useStyles = makeStyles({
  root: {
    fontFamily: 'Noto Sans, Noto Sans Thai, sans-serif', // FIXME: should use from theme
  },
  select: {
    padding: '12px 26px 12px 16px',
  },
});

function SearchFilter(/** @type {SearchFilterProps} */ props) {
  const {
    selectedSection,
    sectionList,
    onSelectSection,
    problemList,
    selectedProblem,
    onSelectProblem,
    onSearch,
    isSearching,
    ...restProps
  } = props;

  const classes = useStyles();
  const isDisableSearch = !selectedSection || !selectedProblem || isSearching;

  const handleSectionChange = (event) => {
    const sectionId = event.target.value;
    onSelectSection(sectionId);
  };

  const handleProblemChange = (event) => {
    const problemId = event.target.value;
    onSelectProblem(problemId);
  };

  return (
    <Wrapper {...restProps}>
      <Select
        labelId={'section-select-label'}
        value={selectedSection}
        onChange={handleSectionChange}
        displayEmpty
        fullWidth
        variant={'outlined'}
        classes={classes}
        renderValue={(selected) => {
          if (selected === '') return 'เลือกบทเรียน';
          return sectionList.find((section) => section.value === selected)?.label;
        }}
      >
        <MenuItem disabled value="">
          เลือกบทเรียน
        </MenuItem>
        {sectionList.map((section) => (
          <MenuItem key={section.value} value={section.value}>
            {section.label}
          </MenuItem>
        ))}
      </Select>

      <Select
        labelId={'problem-select-label'}
        value={selectedProblem}
        onChange={handleProblemChange}
        disabled={!problemList.length}
        variant={'outlined'}
        displayEmpty
        fullWidth
        classes={classes}
        renderValue={(selected) => {
          if (selected === '') return 'เลือกข้อ';
          return problemList.find((problem) => problem.value === selected)?.label;
        }}
      >
        <MenuItem disabled value="">
          เลือกข้อ
        </MenuItem>
        {problemList.map((problem) => (
          <MenuItem key={problem.value} value={problem.value}>
            {problem.label}
          </MenuItem>
        ))}
      </Select>

      <ButtonFilled
        px={8}
        width={148}
        color={'clear.clearDark'}
        textColor={isDisableSearch ? 'clear.clearGrayDark' : 'white'}
        disabled={isDisableSearch}
        onClick={onSearch}
      >
        {'ค้นหา'}
      </ButtonFilled>
    </Wrapper>
  );
}

SearchFilter.propTypes = {
  selectedSection: PropTypes.string,
  sectionList: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })
  ),
  selectedProblem: PropTypes.string,
  problemList: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })
  ),
  onSelectSection: PropTypes.func,
  onSelectProblem: PropTypes.func,
  onSearch: PropTypes.func,
  isSearching: PropTypes.bool,
};

export default SearchFilter;

/**
 * @typedef {Object} SearchFilterProps
 * @property {string} selectedSection
 * @property {number} selectedProblem
 * @property {Array<Option>} sectionList
 * @property {Array<Option>} problemList
 * @property {(sectionId: string) => void} onSelectSection
 * @property {(problemId: string) => void} onSelectProblem
 * @property {() => void} onSearch
 * @property {boolean} isSearching
 *
 * @typedef {Object} Option
 * @property {string} value
 * @property {string} label
 */
